import * as React from 'react';
import { ComponentProps } from 'ui/common';
import { MdHistory } from 'react-icons/md';
import { LogLinkButton } from './common/log-link-button';
import { ChildEntityCountShape } from 'app/area/case/selectors';
import './processing-log-link.scss';

export interface ProcessingLogLinkProps {
  textDone?: string;
  textTitle?: string;
  processingLogs?: ChildEntityCountShape;
  inline?: boolean; 
}

export type ProcessingLogLinkComponentProps = ComponentProps & ProcessingLogLinkProps;

export const ProcessingLogLink: React.SFC<ProcessingLogLinkComponentProps> = props => {
  
  const {
    textDone,
    textTitle,
    inline = false
  } = props;
    
  const hasItems = props.processingLogs && props.processingLogs.count > 0;
  
  return (
    <div className={`${props.className}`}>
      <LogLinkButton {...props} inline={inline} icon={MdHistory} textTitle={textTitle} textDone={textDone} 
        visible={hasItems}/>
    </div>
  );
};

export const ReadProcessingLogLink: React.SFC<ProcessingLogLinkComponentProps> = props => <ProcessingLogLink {...props} inline={true}/>;
